fx.ns("desktop.book.edition", class PhotoListStep extends fx.Component {
    
	constructor(data)
	{
        super(data);

		this._selectAll = false;

		this.destroyOnSwitch = true;
    }

    get title()
    {
        return this._title ? this._title.text : "";
    }

    set title(val)
    {
        if (this._title)
            this._title.text = val;
    }

    get subtitle()
    {
        return this._subtitle ? this._subtitle.text : "";
    }

    set subtitle(val)
    {
        if (this._subtitle)
            this._subtitle.text = val;
    }

	get selectAll()
	{
		return this._selectAll;
	}

	set selectAll(val)
	{
		this._selectAll = val;

		if (this._selectAll)
		{
			for (let i = 0; i< this.data.photos.length; i++)
				this.data.photos.getItemAt(i).selected = true;

			this.selectPhotos.text = fx.text("Sélectionner les meilleures !");
		}
		else
		{
			this.data.creator.selectPictures();
			
			this.selectPhotos.text = fx.text("Tout sélectionner");
		}
	}

    create()
    {
		this.circlesBox = new shared.component.Person(fx.get("assets").photoImportStep1);
		this.addChild(this.circlesBox, {width:160, height : 160, top : 20, left : 0});

		this._title = new fx.components.Text({text : fx.text("J'ai sélectionné vos photos"), className : "title"});
		this._subTitle = new fx.components.Text({text : fx.text("Vous pouvez modifier ma sélection avant de lancer la création intelligente de votre album"), className : "text"});
		this.creationBtn = new fx.components.Button({label : fx.text("Suivant"), type : "filled"});
		this._warningText = new fx.components.Text({text : fx.text("Vous devez ajouter au moins 24 photos"), className : "text warning"});
		this._warningText.visibleAtStart = false;
		
		this.addChild(this._title, {width:"100%", height:60, top : 30, left : 200});
		this.addChild(this._subTitle, {width:"100%", height:40, top : 72, left : 200});
		
		this.addChild(this.creationBtn, {width:300, height : 30, top : 110, left : 185});
		this.addChild(this._warningText, {width:350, height : 30, top : 127, left : 495});

		this.selectPhotos = new fx.components.Text({text : fx.text("Tout sélectionner"), className : "select text-right"});
		this.addChild(this.selectPhotos, {width:200, height : 20, bottom : 10, right : 25});

    }

	onDisplayUpdated()
	{
		super.onDisplayUpdated();
		
		this.circlesBox.left( fx.graphics.screenSize().width < 1150 ? 50 : 0);
		this._title.left( fx.graphics.screenSize().width < 1150 ? 250 : 200);
		this._subTitle.left( fx.graphics.screenSize().width < 1150 ? 250 : 200);
		this.creationBtn.left( fx.graphics.screenSize().width < 1150 ? 235 : 185);
		this._warningText.left( fx.graphics.screenSize().width < 1150 ? 545 : 495);
	}

	small()
	{
		this.height(100);

		this._title.hide();
		this._subTitle.hide()

		this.creationBtn.top(15);
		this._warningText.top(32);
	
		
		this.circlesBox.viewport({width : 100, height : 100, top : 0});

		this.addClass("small");
	}

	big()
	{
		this.height(200);

		this._title.show();
		this._subTitle.show();

		this.creationBtn.top(110);
		this._warningText.top(127);
	
		this.circlesBox.viewport({width : 160, height : 150, top : 20});

		this.removeClass("small");
	}

    onReady()
    {
        
		this.on("click", this._onCreate, this.creationBtn);
		this.on("click", this.toggleSelect, this.selectPhotos);

		if (this.data.photos.length < 24)
		{
			this._warningText.show();
			this.selectPhotos.hide();
			this.creationBtn.disable();
		}
    }

    

	_onCreate()
	{
		//this.data.event("creating-album")
		this.trigger("create");
	}

	toggleSelect()
	{
		this.selectAll = !this.selectAll;
	}



});